import { SvgIconProps } from '@euler/app/components/icons/types';
import { useSvgProps } from '@euler/app/components/icons/util';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ComponentType, FC, memo } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import Animated from 'react-native-reanimated';
import { Path, Svg } from 'react-native-svg';

export const kFormElementCaretDefaultIconSize = 24;

export const FormElementCaret = memo(
  ({
    style,
    Icon = DefaultCaretIcon,
    iconSize,
    iconColor,
  }: {
    style?: StyleProp<ViewStyle>;
    Icon?: ComponentType<SvgIconProps>;
    iconSize?: number;
    iconColor?: string;
  }) => {
    const { rpx } = useResponsiveContext();
    iconSize = iconSize ?? rpx(kFormElementCaretDefaultIconSize);
    return (
      <Animated.View
        style={[
          style,
          {
            justifyContent: 'center',
            alignItems: 'center',
          },
        ]}
      >
        <Icon size={iconSize} color={iconColor} />
      </Animated.View>
    );
  },
);

const DefaultCaretIcon: FC<SvgIconProps> = memo(props => {
  const { fill = '#9498A2', ...svgProps } = useSvgProps(props, 21, 21);
  return (
    <Svg viewBox="0 0 24 24" fill="none" {...svgProps}>
      <Path
        d="M5 15L12 8L19 15"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
});
